export interface Painting {
    title: string,
    size: string,
    medium: string,
    sold: boolean,
    file: string,
    buyLink?: string,
    price?: number,
};

export interface Category {
    title: string,
    file: string,
    paintings: Painting[],
}

export const portfolio: Category[] = [
    {        
        title: "Landscape",
        file: "View of Seattle.jpg",
        paintings: [
            {
                title: "Past and Present",
                size: "7x10",
                medium: "Watercolor",
                sold: true,
                file: "Past and Present.jpg",
            },
            {   
                title: "Mt. Rainier Series - Mt. Rainier Meadows",
                size: "11x7",
                medium: "Watercolor",
                sold: true,
                file: "Mt. Rainier Series - Mt. Rainier Meadow-.jpg",
                price: 275,
            },
            {
                title: "Cherry Blossoms Snoqualmie Depot",
                size: "15x11", 
                medium: "Watercolor",
                sold: true,
                file: "Cherry Blossoms Snoqualmie Depot.jpg",
            },
            {
                title: "Meditation (donated to Pacific Bonsai Museum for fundraiser 2023)",
                size: "11x15",
                medium: "Watercolor",
                sold: true,
                file: "Meditation.jpg",
            },
            {
                title: "Sunset at Northwest",
                size: "7x12",
                medium: "Watercolor",
                sold: true,
                file: "Sunset at Northwest.jpg",
            },
            {
                title: "View of Seattle",
                size: "14x11",
                medium: "Watercolor",
                sold: true,
                file: "View of Seattle.jpg",
            },
            {
                title: "Seattle Chinese Garden",
                size: "21x15",
                medium: "Watercolor",
                sold: true,
                file: "Chinese Garden.jpg",
            },
            {
                title: "Snoqualmie Falls",
                size: "12x16",
                medium: "Watercolor",
                sold: true,
                file: "Snoqualmie Falls.jpg",
            },
            {
                title: "Snoqualmie Steam Train",
                size: "15x11",
                medium: "Watercolor",
                sold: true,
                file: "Snoqualmie Steam Train.jpg",
            },
            {
                title: "Snoqualmie Depot and Train",
                size: "12x9",
                medium: "Watercolor",
                sold: true,
                file: "Snoqualmie Depot and Train.jpg",
            },
            {
                title: "Old Trains, Snoqualmie",
                size: "12x9",
                medium: "Watercolor",
                sold: true,
                file: "Old Trains, Snoqualmie.jpg",
            },
            {
                title: "Mt. Rainier and Seattle Port",
                size: "11x14",
                medium: "Watercolor",
                sold: false,
                file: "Mt. Rainier and Seattle Port.jpg",
            },
            {
                title: "Light House at San Juan Island",
                size: "15x11",
                medium: "Watercolor",
                sold: true,
                file: "Light House at San Juan Island.jpg",
            },
            {
                title: "Seattle Gas Works Park II",
                size: "15x11",
                medium: "Watercolor",
                sold: false,
                file: "Seattle Gas Works Park II.jpg",
            },
            {
                title: "Welcome to Twin Peaks",
                size: "12x9",
                medium: "Watercolor",
                sold: true,
                file: "Welcome to Twin Peaks.jpg",
            },
            {
                title: "Snoqualmie Autumn",
                size: "10x7",
                medium: "Watercolor",
                sold: true,
                file: "Snoqualmie Autumn.jpg",
            },
            {
                title: "Ruby Beach, Olympic",
                size: "20x26",
                medium: "Watercolor",
                sold: true,
                file: "Ruby Beach-2.jpg",
            },
            {
                title: "Mooney Falls",
                size: "20x26",
                medium: "Watercolor",
                sold: true,
                file: "Mooney Falls.jpg",
            },
            {
                title: "Gas Works Park and Seattle",
                size: "12x8",
                medium: "Watercolor",
                sold: true,
                file: "Gas Works Park and Seattle.jpg",
            },
            {
                title: "Elliott Bay Park",
                size: "11x7",
                medium: "Watercolor",
                sold: true,
                file: "Elliott Bay Park.jpg",
            },
            {
                title: "Edmonds Marina Beach",
                size: "22x15",
                medium: "Watercolor",
                sold: false,
                file: "Edmonds Marina Beach.jpg",
                price: 950,
            },
            {
                title: "Seattle Georgetown",
                size: "15x11",
                medium: "Watercolor",
                sold: false,
                file: "Seattle Georgetown.jpg",
            },
            {
                title: "Seattle Commodore Park 2022",
                size: "15x11",
                medium: "Watercolor",
                sold: true,
                file: "Seattle Commodore Park.jpg",
            },
        ]
    },
    {
        title: "Figures",
        file: "Girl and Birds.jpg",
        paintings: [
            {
                title: "Fire Walk With Me, Laura Palmer",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Fire walk with me Laura Palmer.jpg",
            },
            {
                title: "Reading Letter",
                size: "12x16",
                medium: "Watercolor",
                sold: true,
                file: "Reading Letter.jpg",
            },
            {
                title: "Commissioned from Dance",
                size: "8x10",
                medium: "Watercolor",
                sold: true,
                file: "Commissioned I.jpg",
            },
            {
                title: "Ski",
                size: "4x6",
                medium: "Watercolor",
                sold: true,
                file: "Ski.jpg",
            },
            {
                title: "Woman and Cello",
                size: "10x13",
                medium: "Watercolor",
                sold: false,
                file: "Woman and Cello.jpg",
            },
            {
                title: "Summer Time",
                size: "15x25",
                medium: "Watercolor",
                sold: false,
                file: "Summer Time.jpg",
            },
            {
                title: "Moment of Silence",
                size: "15x22",
                medium: "Watercolor",
                sold: false,
                file: "Moment of Silence.jpg",
            },
            {
                title: "Joseph's Welcome",
                size: "20x28",
                medium: "Watercolor",
                sold: true,
                file: "Joseph's Welcome.jpg",
            },
            {
                title: "Boy and Birds (first place award)",
                size: "14x11",
                medium: "Watercolor",
                sold: false,
                file: "Boy and Birds (first place award).jpg",
            },
            {
                title: "Girl with Blue Hat",
                size: "7x11",
                medium: "Watercolor",
                sold: true,
                file: "Girl with Blue Hat.jpg",
            },
            {
                title: "Family Beach Day",
                size: "15x11",
                medium: "Watercolor",
                sold: true,
                file: "Family Beach Day.jpg",
            },
            {
                title: "Girls and Fishes",
                size: "11x15",
                medium: "Watercolor",
                sold: true,
                file: "Girls and Fishes.jpg",
            },
            {
                title: "Kids",
                size: "11x15",
                medium: "Watercolor",
                sold: true,
                file: "Kids.jpg",
            },
            {
                title: "Old man",
                size: "15x11",
                medium: "Watercolor",
                sold: true,
                file: "Old man.jpg",
            },
            {
                title: "Bubble Fun",
                size: "15x11",
                medium: "Watercolor",
                sold: true,
                file: "Bubble Fun 1.jpg",
            },
            {
                title: "Little Girl and Birds",
                size: "7x11",
                medium: "Watercolor",
                sold: true,
                file: "Little Girl and Birds.jpg",
            },
            {
                title: "Father and Son",
                size: "11x15",
                medium: "Watercolor",
                sold: true,
                file: "Father and Son.jpg",
            },
            {
                title: "Magan and Her Boy",
                size: "11x15",
                medium: "Watercolor",
                sold: true,
                file: "Magan and Her Boy.jpg",
            },
            {
                title: "Star Child Little Mary",
                size: "11x15",
                medium: "Watercolor",
                sold: true,
                file: "Star Child Little Mary.jpg",
            },
            {
                title: "Girl and Penguin",
                size: "15x11",
                medium: "Watercolor",
                sold: false,
                file: "Girl and Penguin.jpg",
            },
            {
                title: "Playing at River",
                size: "15x11",
                medium: "Watercolor",
                sold: false,
                file: "Playing at River.jpg",
            },
            {
                title: "Boy and Birds 1",
                size: "12x9",
                medium: "Watercolor",
                sold: true,
                file: "Boy and Birds.jpg",
            },
            {
                title: "I Wish",
                size: "5x10",
                medium: "Watercolor",
                sold: true,
                file: "I Wish.jpg",
            },
            {
                title: "Girl and Birds",
                size: "15x11",
                medium: "Watercolor",
                sold: true,
                file: "Girl and Birds.jpg",
            },
        ]
    },
    {
        title: "Small Works",
        file: "Tulip Festival.jpg",
        paintings: [

            {
                title: "Reflection",
                size: "5x7",
                medium: "Watercolor",
                sold: true,
                file: "Reflection.jpg",
            },
            {
                title: "Reflection-2",
                size: "5x7",
                medium: "Watercolor",
                sold: true,
                file: "Reflection 2.jpg",
            },
            {
                title: "Gathering 2",
                size: "3x5",
                medium: "Watercolor",
                sold: true,
                file: "Gathering 2.jpg",
            },
            {
                title: "First Snow",
                size: "3x5",
                medium: "Watercolor",
                sold: true,
                file: "First Snow.jpg",
            },
            {
                title: "Mountain Ski",
                size: "5x3",
                medium: "Watercolor",
                sold: true,
                file: "Mountain Ski.jpg",
            },
            {
                title: "Snoqualmie Falls, June",
                size: "5x7",
                medium: "Watercolor",
                sold: true,
                file: "Snoqualmie Falls, June Evening.jpg",
            },
           {
                title: "Mt. Rainier and Wildflowers",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Mt. Rainier Series- Mt. Rainier and wildflowers.jpg",   
            },
            {
                title: "Mt. Rainier and Reflection Lake",
                size: "4x3",
                medium: "Acrylic",
                sold: true,
                file: "Mt. Rainier and Reflection Lake.jpg",
            },
            {
                title: "Sunset Beach",
                size: "5x7",
                medium: "Acrylic",
                sold: true,
                file: "Sunset Beach.jpg",
            },
            {
                title: "Twin Peaks Misty",
                size: "3x5",
                medium: "Watercolor",
                sold: true,
                file: "Twin Peaks Misty.jpg",
            },
            {
                title: "Mountain Out-4",
                size: "7x10",
                medium: "Watercolor",
                sold: true,
                file: "Mountain Out 4.jpg",
            },
            {
                title: "Mountain Out-5",
                size: "7x10",
                medium: "Watercolor",
                sold: true,
                file: "Mountain out 5.jpg",
            },
            {
                title: "Mountain Out-6",
                size: "7x10",
                medium: "Watercolor",
                sold: true,
                file: "Mountain out 6.jpg",
            },
            {
                title: "Twin Peaks Misty 2",
                size: "3x5",
                medium: "Watercolor",
                sold: true,
                file: "Twin Peak Misty 2.jpg",
            },
            {
                title: "Sunflowers in Vase",
                size: "3x4",
                medium: "Acrylic",
                sold: true,
                file: "Sunflowers in Vase.jpg",
            },
            {
                title: "Elks at Snoqualmie Valley",
                size: "5x3",
                medium: "Watercolor",
                sold: true,
                file: "Elks at Snoqualmie Valley.jpg",
            },
            {
                title: "Snoqualmie Falls, Sunset 2",
                size: "3x5",
                medium: "Watercolor",
                sold: true,
                file: "Snoqualmie Falls, Sunset 2.jpg",
            },
            {
                title: "Mukilteo Lighthouse",
                size: "5x3",
                medium: "Watercolor",
                sold: true,
                file: "Mukilteo Lighhouse.jpg",
            },
            {
                title: "Mountain Out 3",
                size: "5x3",
                medium: "Watercolor",
                sold: true,
                file: "Mountain Out 3.jpg",
            },
            {
                title: "Mountain Out",
                size: "3x5",
                medium: "Watercolor",
                sold: true,
                file: "Mountain Out.jpg", 
            },
            {
                title: "Misty Cascade Forest",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Misty Cascade Forest.jpg", 
            },
            {
                title: "Forest and Shadow",
                size: "4x6",
                medium: "Watercolor",
                sold: true,
                file: "Forest and Shadow.jpg",   
            },
            {
                title: "Foggy Forest and Islands",
                size: "5x3",
                medium: "Watercolor",
                sold: true,
                file: "Foggy Forest and Islands.jpg",
                price: 125,   
            },
            {   
                title: "Mt. Rainier Series - Mt. Rainier and Wildflowers",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Mt. Rainier Series - Mt. Rainier and wildflowers.jpg",
                
            },
            {
                title: "Snoqualmie Falls and Hotel",
                size: "7x5",
                medium: "watercolor",
                sold: true,
                file: "Snoqualmie Falls and Hotel.jpg",
            },
            {
                title: "Bumble Bees",
                size: "7x5",
                medium: "watercolor",
                sold: true,
                file: "BumbleBees 1.jpg",
            },
            {
                title: "Misty Forest",
                size: "3x5",
                medium: "watercolor",
                sold: true,
                file: "Misty Forest.jpg",
            },
            {
                title: "Misty Mt. Si.",
                size: "7x5",
                medium: "watercolor",
                sold: true,
                file: "Misty Mt. Si.jpg",
            },
            {
                title: "Two Pumpkins",
                size: "7x5",
                medium: "watercolor",
                sold: true,
                file: "Two Pumpkins.jpg",
            },
             {
                title: "Sunflowers 3",
                size: "4x6",
                medium: "watercolor",
                sold: true,
                file: "SunFlowers 3.jpg",
            },
            {
                title: "Hydrangeas",
                size: "7x5",
                medium: "Oil",
                sold: true,
                file: "Hydrangeas.jpg",
            },
            {   
                title: "Mt. Rainier Series - Mt. Rainier and Gig Harbor",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Mt. Rainier Series - Mt. Rainier and Gig Harbor-.jpg",
                price: 175,
            },
            {
                title: "Seattle Alki Point Lighhouse",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Seattle Alki Point Lighthouse.jpg",
            },
           {
                title: "Twede's Cafe",
                size: "5x7",
                medium: "Watercolor",
                sold: true,
                file: "twede's cafe.jpg",
            },
            {
                title: "Damn Good Cherry Pie",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Damn Good Cheery Pie.jpg",
            },
            {
                title: "Sunflowers 1",
                size: "4x6",
                medium: "Watercolor",
                sold: true,
                file: "Sunflowers 1.jpg",
            },
            {
                title: "Blue Heron Northwest",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Blue Herons Northwest.jpg",
            },
            {
                title: "Story of A Little House",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Stroy of Little House.jpg",
            },
            {
                title: "Sunflowers",
                size: "4x6",
                medium: "Watercolor and ink",
                sold: true,
                file: "Sunflowers3.jpg",
            },
            {
                title: "Bumble Bees and Lavender 2",
                size: "4x6",
                medium: "Watercolor",
                sold: true,
                file: "Bumble Bees and Lavender 2.jpg",
            },
            {
                title: "Bumble Bees and Lavender 1",
                size: "6x4",
                medium: "Watercolor",
                sold: true,
                file: "Bumble Bees and Lavender 1.jpg",
            },
            {
                title: "Bumble Bees and Thistles 2",
                size: "4x6",
                medium: "Watercolor",
                sold: true,
                file: "Bumble Bees and Thistles 2.jpg",
            },
            {
                title: "Bumble Bees and Thistles 1",
                size: "4x6",
                medium: "Watercolor",
                sold: true,
                file: "Bumble Bees and Thistles 1.jpg",
            },
            {
                title: "Cherry Blossoms at Snoqualmie",
                size: "5x5",
                medium: "Watercolor",
                sold: true,
                file: "Cherry Blossoms at Snoqualmie.jpg",
            },
            {
                title: "Ruby Beach, Olympic",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Ruby Beach, Olympic.jpg",
            },
            {
                title: "Great Blue Heron",
                size: "5x7",
                medium: "Watercolor",
                sold: true,
                file: "Great Blue Heron.jpg",
            },
            {
                title: "Port of Tacoma",
                size: "5x7",
                medium: "Watercolor",
                sold: true,
                file: "Port of Tacoma.jpg",
            },
            {
                title: "Snoqualmie Falls, Sunset",
                size: "5x7",
                medium: "Watercolor",
                sold: true,
                file: "Snoqualmie Falls, Sunset.jpg",
            },
            {
                title: "Mt. Si. and North Bend",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Mt. Si. and North Bend.jpg",
            },
            {
                title: "Sunset, Snoqualmie Falls",
                size: "5x7",
                medium: "Watercolor",
                sold: true,
                file: "Sunset, Snoqualmie Falls.jpg",
            },
            {
                title: "Snoqualmie Falls, Frozen",
                size: "4x6",
                medium: "Watercolor",
                sold: true,
                file: "Snoqualmie Falls, Frozen.jpg",
            },
            {
                title: "Mt. Rainier and Gig Harbor",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Mt. Rainier and Gig Harbor.jpg",
            },
            {
                title: "Olympic Beach",
                size: "4x6",
                medium: "Watercolor",
                sold: true,
                file: "Olympic Beach.jpg",
            },
            {
                title: "Snoqualmie Train Station, Winter",
                size: "4x6",
                medium: "Watercolor",
                sold: true,
                file: "Snoqualmie Train Station, Winter.jpg",
            },
            {
                title: "Snoqualmie Falls",
                size: "5x7",
                medium: "Watercolor",
                sold: true,
                file: "Snoqualmie Falls-28.jpg",
            },
            {
                title: "After Rain in Seattle",
                size: "5x7",
                medium: "Watercolor",
                sold: true,
                file: "After Rain in Seattle.jpg",
            },
            {
                title: "Pacific Northwest Beach",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Pacific Northwest Beach.jpg",
            },
            {
                title: "Mooney Falls",
                size: "6x8",
                medium: "Watercolor",
                sold: true,
                file: "Mooney Falls.jpg",
            },
            {
                title: "Sunflowers and Ladybugs",
                size: "5x7",
                medium: "Watercolor",
                sold: true,
                file: "Sunflowers and Ladybugs.jpg",
            },
            {
                title: "Pacific Rainforest, Snow",
                size: "4x6",
                medium: "Watercolor",
                sold: true,
                file: "Pacific Rainforest, Snow.jpg",
            },
            {
                title: "Snoqualmie Falls, Grey Day",
                size: "4x6",
                medium: "Watercolor",
                sold: true,
                file: "Snoqualmie Falls, Grey Day.jpg",
            },
            {
                title: "RedWinged Black Bird",
                size: "4x6",
                medium: "Watercolor",
                sold: true,
                file: "RedWinged Black Bird.jpg",
            },
            {
                title: "Snoqualmie Falls",
                size: "5x7",
                medium: "Watercolor",
                sold: true,
                file: "Snoqualmie Falls-20.jpg",
            },
            {
                title: "Gathering",
                size: "4x6",
                medium: "Watercolor",
                sold: true,
                file: "Gathering.jpg",
            },
            {
                title: "Light House at Discovery",
                size: "8x6",
                medium: "Watercolor",
                sold: true,
                file: "Light House at Discovery.jpg",
            },
            {
                title: "Snow day at Snoqualmie Train",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Snow day at Snoqualmie Train.jpg",
            },
            {
                title: "Snoqualmie Falls, Blue Day",
                size: "4x6",
                medium: "Watercolor",
                sold: true,
                file: "Snoqualmie Falls, Blue Day.jpg",
            },
            {
                title: "Old Steam Engine",
                size: "6x8",
                medium: "Watercolor",
                sold: true,
                file: "Old Steam Engine.jpg",
            },
            {
                title: "Seattle Space Needle",
                size: "8x6",
                medium: "Watercolor",
                sold: true,
                file: "Seattle Space Needle.jpg",
            },
            {
                title: "All Beauty in Northwest",
                size: "6x4",
                medium: "Watercolor",
                sold: true,
                file: "All Beauty in Northwest-13.jpg",
            },
            {
                title: "Snoqualmie Train Station Winter Snow",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Snoqualmie Train Station Winter Snow.jpg",
            },
            {
                title: "Mt. Rainier",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Mt. Rainier.jpg",
            },
            {
                title: "Tulip Festival",
                size: "6x4",
                medium: "Watercolor",
                sold: true,
                file: "Tulip Festival.jpg",
            },
            {
                title: "Snoqualmie River",
                size: "5x7",
                medium: "Watercolor",
                sold: true,
                file: "Snoqualmie River.jpg",
            },
            {
                title: "Moon Falls and Elk",
                size: "5x7",
                medium: "Watercolor",
                sold: true,
                file: "Moon Falls and Elk.jpg",
            },
            {
                title: "Snoqualmie Falls",
                size: "4x6",
                medium: "Watercolor",
                sold: true,
                file: "Snoqualmie Falls-7.jpg",
            },
            {
                title: "Mt. Rainier Spring",
                size: "5x7",
                medium: "Watercolor",
                sold: true,
                file: "Mt. Rainier Spring.jpg",
            },
            {
                title: "MeadowBrook and Elks",
                size: "5x7",
                medium: "Watercolor",
                sold: true,
                file: "MeadowBrook and Elks.jpg",
            },
            {
                title: "Snoqualmie Falls, Raining Day",
                size: "4x6",
                medium: "Watercolor",
                sold: true,
                file: "Snoqualmie Falls, Raining Day.jpg",
            },
            {
                title: "Grand Canyon Yavapai Lodge",
                size: "11x7",
                medium: "Watercolor",
                sold: false,
                file: "Grand Canyon Yavapai Lodge.jpg",
            },
        ]
    },
    {
        title: "Animals",
        file: "Pet Duck 1.jpg",
        paintings: [

            {
                title: "Cat and Mice 29",
                size: "3x5",
                medium: "Watercolor",
                sold: true,
                file: "Cat and Mice 29.jpg",
            },
            {
                title: "Cat and Mice 18",
                size: "3x5",
                medium: "Watercolor",
                sold: true,
                file: "Cat and Mice 18.jpg",
            },
            {
                title: "Cat and Mice 14",
                size: "3x5",
                medium: "Watercolor",
                sold: true,
                file: "Cat and Mice 14.jpg",
            },
            {
                title: "Cat and Mice 13",
                size: "3x5",
                medium: "Watercolor",
                sold: true,
                file: "Cat and Mice 13.jpg",
            },
            {
                title: "Cat and Mice 12",
                size: "3x5",
                medium: "Watercolor",
                sold: true,
                file: "Cat and Mice 12.jpg",
            },
            {
                title: "Cat and Mice 11",
                size: "3x5",
                medium: "Watercolor",
                sold: true,
                file: "Cat and Mice 11.jpg",
            },
            {
                title: "Cat and Mice 9",
                size: "3x5",
                medium: "Watercolor",
                sold: true,
                file: "Cat and Mice 9.jpg",
            },
            {
                title: "Tuxedo Cat",
                size: "3x5",
                medium: "Watercolor",
                sold: true,
                file: "Tuxedo Cat.jpg",
            },
            {
                title: "Cat and Mice 5 ",
                size: "3x5",
                medium: "Watercolor",
                sold: true,
                file: "Cat and Mice 5.jpg",
            },
            {
                title: "Cat and Mice 6",
                size: "3x5",
                medium: "Watercolor",
                sold: true,
                file: "Cat and Mice 6.jpg",
            },
            {
                title: "Cat and Mice 7 ",
                size: "3x5",
                medium: "Watercolor",
                sold: true,
                file: "Cat and Mice 7.jpg",
            },{
                title: "Cat and Mice 16",
                size: "3x5",
                medium: "Watercolor",
                sold: true,
                file: "Cat and Mice 16.jpg",
            },
            {
                title: "Cat ",
                size: "5x7",
                medium: "Watercolor",
                sold: true,
                file: "Cat I.jpg",
            },
           {
                title: "Flying South",
                size: "6x4",
                medium: "Watercolor",
                sold: true,
                file: "Flying South.jpg",
            },
            {
                title: "Rooster",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Rooster.jpg",
            },
            {
                title: "Cat and Mice 2",
                size: "4x6",
                medium: "Watercolor",
                sold: true,
                file: "Cat and Mice 002.jpg",
            },
            {
                title: "Hawaiian Rooster",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Hawaiian Rooster.jpg",
            },
            {
                title: "Forest and Horse",
                size: "8x6",
                medium: "Watercolor",
                sold: true,
                file: "Forest and Horse.jpg",
            },
            {
                title: "Snow Owl Study",
                size: "6x4",
                medium: "Watercolor",
                sold: true,
                file: "Snow Owl study.jpg",
            },
            {
                title: "Dancing in Water",
                size: "4x6",
                medium: "Watercolor",
                sold: true,
                file: "Dancing in Water.jpg",
            },
            {
                title: "Kitten",
                size: "8x6",
                medium: "Watercolor",
                sold: true,
                file: "Kitten.jpg",
            },
            {
                title: "Chasing",
                size: "6x4",
                medium: "Watercolor",
                sold: true,
                file: "Chasing.jpg",
            },
            {
                title: "Observing",
                size: "5x7",
                medium: "Watercolor",
                sold: true,
                file: "Observing.jpg",
            },

            {
                title: "Cat and Mice",
                size: "4x6",
                medium: "Watercolor",
                sold: true,
                file: "Cat and Mice.jpg",
            },
            {
                title: "Golden Mantel Squirrel",
                size: "6x8",
                medium: "Watercolor",
                sold: false,
                file: "Golden Mantel Squarel.jpg",
            },
            {
                title: "Good Morning",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Good Morning.jpg",
            },
            {
                title: "Pet Duck 1",
                size: "11x7",
                medium: "Watercolor",
                sold: true,
                file: "Pet Duck 1.jpg",
            },
        ]
    },
]

export const store: Category[] = [
    {
        title: "Available Original Work",
        file: "Seattle Fisherman Terminal.jpg",
        paintings: [
            {
                title: "Autumn Joy, Kubota Garden",
                size: "12x9",
                medium: "Watercolor",
                sold: false,
                file: "*Japanese Garden.jpg",
                price: 275,
                buyLink: "https://square.link/u/tPMQaC13",
            },
            {   
                title: "Ocean Breeze, Edmonds Beach",
                size: "13x7",
                medium: "Watercolor",
                sold: false,
                file: "*Edmonds Beach-.jpg",
                price: 250,
                buyLink: "https://square.link/u/zI9kpBYr",
            },
            {   
                title: "Ferry Crossing Lincoln Park",
                size: "7x11",
                medium: "Watercolor",
                sold: false,
                file: "Ferry Crossing Lincoln Park-.jpg",
                price: 275,
                buyLink: "https://square.link/u/aez3w20V",
            },
            
            {   
                title: "Lighthouse Series - Admiralty Head Lighhouse",
                size: "7x5",
                medium: "Watercolor",
                sold: false,
                file: "Lighthouse series - Admiralty head lighhouse-.jpg",
                price: 175,
                buyLink: "https://square.link/u/pXB6TuXu",
            },
            {   
                title: "Lighthouse Series - Point Wilson Lighthouse",
                size: "7x5",
                medium: "Watercolor",
                sold: false,
                file: "Lighthouse series - Point Wilson Lighthouse-.jpg",
                price: 175,
                buyLink: "https://square.link/u/SKOZkq3O",
            },
            {   
                title: "Mt. Rainier Series - Mt. Rainier and Gig Harbor",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Mt. Rainier Series - Mt. Rainier and Gig Harbor-.jpg",
                price: 175,
            },
            {   
                title: "Mt. Rainier Series - Mt. Rainier and Wildflowers",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Mt. Rainier Series - Mt. Rainier and wildflowers.jpg",
                price: 150,
                
            },
            {   
                title: "Mt. Rainier Series - Mt. Rainier Meadows",
                size: "11x7",
                medium: "Watercolor",
                sold: true,
                file: "Mt. Rainier Series - Mt. Rainier Meadow-.jpg",
                price: 275,
            },
            {   
                title: "Obstruction Island",
                size: "12x9",
                medium: "Watercolor",
                sold: false,
                file: "Obstruction Island-.jpg",
                price: 400,
                buyLink: "https://square.link/u/RUInIPUk",
            },
            {
                title: "Blue Heron Northwest",
                size: "4x4",
                medium: "Watercolor",
                sold: true,
                file: "Blue Heron Northwest.jpg",
                price: 95,
                
            },
            {
                title: "As Above, So Below",
                size: "7x11",
                medium: "Watercolor",
                sold: false,
                file: "As Above, So Below.jpg",
                price: 275,
                buyLink: "https://square.link/u/GtrMkzVQ"
            },
            {
                title: "Reaching Up",
                size: "7x11",
                medium: "Watercolor",
                sold: false,
                file: "Reaching Up.jpg",
                price: 275,
                buyLink: "https://square.link/u/VoKK4WS5",
            },
            {
                title: "Spirit at Daybreak",
                size: "7x11",
                medium: "Watercolor",
                sold: false,
                file: "*Spirit at Daybreak.jpg",
                price: 195,
                buyLink: "https://square.link/u/7AvX7g7p"
            },
            {
                title: "Daybreak Star Indian Cultural Center",
                size: "7x11",
                medium: "Watercolor",
                sold: false,
                file: "*Daybreak Star Indian Cultural Center.jpg",
                price: 195,
                buyLink: "https://square.link/u/es0XmQGT"
            },
            {
                title: "Seattle Gas Works Park",
                size: "15x11",
                medium: "Watercolor",
                sold: false,
                file: "*Seattle Gas Works Park.jpg",
                price: 600,
                buyLink: "https://square.link/u/qOlf526m",
            },
            {
                title: "Seattle Fisherman Terminal",
                size: "11x14",
                medium: "Watercolor",
                sold: false,
                file: "Seattle Fisherman Terminal.jpg",
                price: 750,
                buyLink: "https://square.link/u/1Ox9sMxh",
            },
            {   
                title: "Seward Park, Seattle",
                size: "11x7",
                medium: "Watercolor",
                sold: false,
                file: "seward park seattle-.jpg",
                price: 275,
                buyLink: "https://square.link/u/Mc7P2NgS",
            },
            {
                title: "South Park Duwamish River Seattle",
                size: "15x11",
                medium: "Watercolor",
                sold: false,
                file: "South Park Duwamish River Seattle.jpg",
                price: 500,
                buyLink: "https://square.link/u/8rPWdxPW",
            },
            {   
                title: "Snow at Ridge",
                size: "7x5",
                medium: "Watercolor",
                sold: false,
                file: "Snow at Ridge.jpg",
                price: 175,
                buyLink: "https://square.link/u/DFP0NY0W",
            },
            {   
                title: "South Park Bridge, Seattle",
                size: "11x7",
                medium: "Watercolor",
                sold: false,
                file: "South Park Bridge Seattle-.jpg",
                price: 275,
                buyLink: "https://square.link/u/5Dw8C5lc",
            },
            {   
                title: "Two Pumpkins",
                size: "7x5",
                medium: "Watercolor",
                sold: true,
                file: "Two Pumpkins-.jpg",
                price: 150,
            },
            {
                title: "Union Bay Boglands",
                size: "15x11",
                medium: "Watercolor",
                sold: false,
                file: "*Union Bay Boglands.jpg",
                price: 450,
                buyLink: "https://square.link/u/hg9OcSKF",
            },

        ]
    },
    // {
    //     title: "Prints",
    //     file: "Mt. Rainier Series - Mt. Rainier Meadow-.jpg",
    //     paintings: [

    //     ]
    // }
]

// Utility to find a category in both portfolio and store
export function findCategory(title: string): Category | undefined {
  return (
    portfolio.find((cat) => cat.title === title) ||
    store.find((cat) => cat.title === title)
  );
}
